export default function CustomLoader({
  fontSize = 24,
  color = "#6c757d",
  title = "Түр хүлээнэ үү...",
  showTitle = false,
}) {
  return (
    <div
      className={`d-flex flex-column align-items-center ${
        showTitle && "gap-2"
      }`}
    >
      <i className="mdi mdi-dots-circle mdi-spin" style={{ fontSize, color }} />
      {showTitle && <p className="text-muted">{title}</p>}
    </div>
  );
}
